import React from 'react';
import {Route, Switch } from 'react-router-dom';

// Components
import Dashboard from "views/wms/dashboard/index";
import Picking from "./picking";
import Sorting from "./sorting";
import Task from "./task";
import Packing from "./packing";
import Shipping from "./shipping";
import TriShipping from "./triShipping";
import CcReceptionList from "./ccReceptionList";
import CreatePickingMission from "./createPickingMission";
import ClickAndCollectList from "./clickAndCollect/list";
import ClickAndCollectHandHover from "./clickAndCollect/handOver";
import MissionModelListIndex from "./missionModelList";
import MissionList from "./missionList/";
import Logs from "./logs";

// Contexts
import {BarCodeScannerProvider} from "contexts/barCodeScannerContext";

// Utils
import {WMSRoutes} from "utils/WMSRoutes";
import WmsAssociations from "./associations";
import WMSContextProvider from "./context/WMSContextProvider";
import WMSSummary from "./admin/WmsResume";
import WMSStats from "./admin/WmsStats";

function WMS(props) {
    return (
        <WMSContextProvider history={props.history}>
            <BarCodeScannerProvider>
                    <Switch>
                        <Route path={WMSRoutes.DASHBOARD} exact component={Dashboard} />
                        <Route path={WMSRoutes.PICKING} exact component={Picking} />
                        <Route path={`${WMSRoutes.PICKING}/:taskId/:containerBarcode`} exact component={Task} />
                        <Route path={WMSRoutes.SORTING} exact component={Sorting} />
                        <Route path={WMSRoutes.PACKING} exact component={Packing} />
                        <Route path={WMSRoutes.TRI_SHIPPING} exact component={TriShipping} />
                        <Route path={WMSRoutes.SHIPPING} exact component={Shipping} />
                        <Route path={WMSRoutes.ASSOCIATION} exact component={WmsAssociations} />
                        <Route path={WMSRoutes.NEW_MISSION} exact component={CreatePickingMission}/>
                        <Route path={`${WMSRoutes.NEW_MISSION}/:modelId`} exact component={CreatePickingMission} />
                        <Route path={WMSRoutes.MISSION_MODEL_LIST} exact component={MissionModelListIndex} />
                        <Route path={WMSRoutes.MISSION_LIST} exact component={MissionList} />
                        <Route path={WMSRoutes.CC_LIST} exact component={ClickAndCollectList} />
                        <Route path={WMSRoutes.CC_HAND_OVER} exact component={ClickAndCollectHandHover} />
                        <Route path={WMSRoutes.CC_RECEPTION_LIST} exact component={CcReceptionList} />
                        <Route path={WMSRoutes.LOGS} exact component={Logs} />
                        <Route path={`${WMSRoutes.LOGS}/:itemId/:itemType`} exact component={Logs} />
                        <Route path={`${WMSRoutes.ADMIN_WMS_SUMMARY}`} exact component={WMSSummary} />
                        <Route path={`${WMSRoutes.ADMIN_WMS_STATS}`} exact component={WMSStats} />
                    </Switch>
            </BarCodeScannerProvider>
        </WMSContextProvider>
    );
}

export default WMS;
